import React, { useEffect, useRef } from "react";
import connect from "Shared/connect";
import MenuColumn from "./MenuColumn";
import { closeMainMenu, toggleMainMenu } from "../action-creators";
import * as styles from "./base.scss";
import classnames from "classnames";
import ShortcutButtons from "../../../Cms/Blocks/ShortcutButtonsBlock/ShortcutButtonsBlock";
import { LARGE } from "Shared/breakpoints";
const MainMenuDesktop = (props) => {
    const ref = useRef(null);
    useEffect(() => {
        if (props.currentBreakpoint < LARGE) {
            props.closeMainMenu();
        }
    }, [props.currentBreakpoint, props.isOpen]);
    return (props.isOpen && (React.createElement("nav", { ref: ref, className: classnames(styles.base, styles.menuWrapper, "ui-test-desktop-menu-nav") },
        React.createElement("div", { "data-opti-id": "menu-categories", className: styles.menuContainer },
            React.createElement(MenuColumn, { className: styles.primary, items: props.primaryMenuItems, categoryIcons: props.categoryIcons })),
        React.createElement("div", { className: styles.shortcutButtonWrapper, "opti-data-id": "component-shortcut-button-block" }, !!props.mainMenu.shortcutButtons &&
            !!(props.mainMenu.shortcutButtons.buttons.length > 0) && (React.createElement(ShortcutButtons, { buttons: props.mainMenu.shortcutButtons.buttons, header: props.mainMenu.shortcutButtons.header, disableTopPadding: props.mainMenu.shortcutButtons.disableTopPadding, backgroundColor: props.mainMenu.shortcutButtons.backgroundColor, headerLevel: props.mainMenu.shortcutButtons.headerLevel, padding: props.mainMenu.shortcutButtons.padding }))))));
};
export default connect((state) => ({
    isOpen: state.mainMenu.isOpen,
    primaryMenuItems: state.mainMenu,
    currentBreakpoint: state.currentBreakpoint,
    categoryIcons: state.appShellData.categoryIcons,
    mainMenu: state.mainMenu,
}), (dispatch) => ({
    toggleMainMenu: () => dispatch(toggleMainMenu()),
    closeMainMenu: () => dispatch(closeMainMenu()),
}))(MainMenuDesktop);
